"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInputColor = exports.InputColor = exports.InputColorDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var field_container_1 = require("../elements/field-container");
var theme_1 = require("@shapeable/theme");
var react_color_1 = require("react-color");
var use_lang_1 = require("../../hooks/use-lang");
exports.InputColorDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .sketch-picker {\n      border-radius: 0 !important;\n    }\n  "], ["\n    .sketch-picker {\n      border-radius: 0 !important;\n    }\n  "])))
});
var SwatchStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: #fff;\n    display: flex;\n    position: relative;\n    flex-direction: row;\n    align-items: center;\n\n  "], ["\n    background: #fff;\n    display: flex;\n    position: relative;\n    flex-direction: row;\n    align-items: center;\n\n  "])))
});
var WellStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    position: absolute;\n    padding: 0;\n    left: ", ";\n    top: ", ";\n    width: ", ";\n    box-sizing: border-box;\n    border: none;\n    height: ", ";\n    cursor: pointer;\n    margin-right: ", ";\n    border: 1px solid ", ";\n\n    ", "\n\n    ", "\n\n  "], ["\n    ", ";\n    position: absolute;\n    padding: 0;\n    left: ", ";\n    top: ", ";\n    width: ", ";\n    box-sizing: border-box;\n    border: none;\n    height: ", ";\n    cursor: pointer;\n    margin-right: ", ";\n    border: 1px solid ", ";\n\n    ", "\n\n    ", "\n\n  "])), theme_1.theme.REMOVE_BUTTON_STYLE(), theme_1.theme.UNIT(3, 2), theme_1.theme.UNIT(3, 3), theme_1.theme.UNIT(6), theme_1.theme.UNIT(6), theme_1.theme.UNIT(4), theme_1.theme.COLOR('line-subtle'), function (props) {
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), props._color);
  }, function (props) {
    return !props._color && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      border: 2px dotted ", ";\n    "], ["\n      border: 2px dotted ", ";\n    "])), theme_1.theme.COLOR('line-mid'));
  })
});
var PopoverStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 122;\n    top: 58px;\n    left: 1px;\n  "], ["\n    position: absolute;\n    z-index: 122;\n    top: 58px;\n    left: 1px;\n  "])))
});
var LayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
var InputStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    padding: ", " ", " ", " ", ";\n    font-family: ", ";\n    text-transform: uppercase;\n    font-weight: 400;\n    font-size: ", ";\n    width: 164px;\n\n    &::placeholder {\n      text-transform: none;\n      color: ", ";\n    }\n\n    &:focus {\n      outline: none;\n      border-color: ", ";\n    }\n  "], ["\n    border: 1px solid ", ";\n    padding: ", " ", " ", " ", ";\n    font-family: ", ";\n    text-transform: uppercase;\n    font-weight: 400;\n    font-size: ", ";\n    width: 164px;\n\n    &::placeholder {\n      text-transform: none;\n      color: ", ";\n    }\n\n    &:focus {\n      outline: none;\n      border-color: ", ";\n    }\n  "])), theme_1.theme.COLOR('line-mid'), theme_1.theme.UNIT(4), theme_1.theme.UNIT(2), theme_1.theme.UNIT(4), theme_1.theme.UNIT(12), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(15), theme_1.theme.COLOR('text-subtle'), theme_1.theme.COLOR('primary'))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    font-weight: 400;\n    font-size: ", ";\n\n    ", "\n  "], ["\n    font-weight: 400;\n    font-size: ", ";\n\n    ", "\n  "])), theme_1.theme.FONT_SIZE(14), function (props) {
    return (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      color: ", ";\n      text-transform: ", ";\n    "], ["\n      color: ", ";\n      text-transform: ", ";\n    "])), theme_1.theme.COLOR(props.hasValue ? 'text' : 'text-subtle'), props.hasValue ? 'uppercase' : 'none');
  })
});
var CoverStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  "], ["\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  "])))
});
var PickerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Swatch: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), SwatchStyles),
  Well: styled_components_1.default.button(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), WellStyles),
  Label: styled_components_1.default.span(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Input: styled_components_1.default.input(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  Popover: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), PopoverStyles),
  Cover: styled_components_1.default.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), CoverStyles),
  Picker: (0, styled_components_1.default)(react_color_1.SketchPicker)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), PickerStyles)
};
var InputColor = function (props) {
  var className = props.className,
    field = props.field,
    onChange = props.onChange;
  var value = field.value,
    name = field.name;
  var _a = __read(React.useState(false), 2),
    visible = _a[0],
    setVisible = _a[1];
  var handleClick = function () {
    setVisible(!visible);
  };
  var handleClose = function () {
    setVisible(false);
  };
  var handleInputChange = function (event) {
    var target = event.target;
    var value = target && target.value;
    onChange({
      name: name,
      value: value
    });
  };
  var handleChange = function (color) {
    onChange({
      name: name,
      value: color.hex
    });
  };
  var t = (0, use_lang_1.useLang)();
  return React.createElement(My.Container, {
    field: field,
    className: className
  }, React.createElement(My.Layout, null, React.createElement(My.Swatch, null, React.createElement(My.Well, {
    type: "button",
    _color: value,
    onClick: handleClick
  }), React.createElement(My.Input, {
    onChange: handleInputChange,
    placeholder: t('(None)'),
    value: value
  })), visible && React.createElement(My.Popover, null, React.createElement(My.Cover, {
    onClick: handleClose
  }), React.createElement(react_color_1.SketchPicker, {
    presetColors: [{
      color: '#FCB017',
      title: 'Shapeable'
    }, {
      color: '#FF5307',
      title: 'Blaze'
    }, {
      color: '#DE3931',
      title: 'Tribe'
    }, {
      color: '#F82B60',
      title: 'Heart'
    }, {
      color: '#7DB248',
      title: 'Bio'
    }, {
      color: '#53AEAA',
      title: 'Ocean'
    }, {
      color: '#064DFF',
      title: 'Learn'
    }, {
      color: '#172C54',
      title: 'Justice'
    }],
    color: value,
    onChange: handleChange
  }))));
};
exports.InputColor = InputColor;
exports.InputColor.defaultProps = exports.InputColorDefaultProps;
var createInputColor = function (props) {
  return React.createElement(exports.InputColor, __assign({}, props));
};
exports.createInputColor = createInputColor;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;